import type { QueryClient } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

/**
 * Invalidate every read-side query that reflects a sales-order draft's
 * gate state — discount validation pills, the legacy order-approval
 * status, and the composed draft-gate status that drives the banner.
 *
 * Mutations that change the draft (line edits, discount decisions,
 * order-approval decisions) call this so all downstream UI re-fetches
 * in lockstep instead of staying out of sync.
 */
export function invalidateDraftSurfaces(
  queryClient: QueryClient,
  stagedPurchaseOrderId: string,
): void {
  const validationKey =
    orpc.accountsReceivable.salesOrderDrafts.validateDiscounts.queryOptions({
      input: { stagedPurchaseOrderId },
    }).queryKey;
  void queryClient.invalidateQueries({ queryKey: validationKey });

  const orderApprovalStatusKey =
    orpc.accountsReceivable.orderApprovals.getStatus.queryOptions({
      input: { stagedPurchaseOrderId },
    }).queryKey;
  void queryClient.invalidateQueries({ queryKey: orderApprovalStatusKey });

  const gateStatusKey =
    orpc.accountsReceivable.orderApprovals.getDraftGateStatus.queryOptions({
      input: { stagedPurchaseOrderId },
    }).queryKey;
  void queryClient.invalidateQueries({ queryKey: gateStatusKey });
}
